const normalizeFieldValue = field => {
  if (!field) {
    return undefined;
  }

  if (field.value !== undefined && field.value !== null) {
    return field.value;
  }

  if (field.values !== undefined && field.values !== null) {
    return field.values;
  }

  if (field.checked !== undefined) {
    return field.checked;
  }

  return undefined;
};

export default normalizeFieldValue;
